module.exports = __webpack_public_path__ + "img/homework_returned.ab9efb22.png";